"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgMoreOptions(props) {
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 20a2 2 0 104.001-.001 2 2 0 00-4.001 0zM17.869 20.05a2 2 0 104.002-.003 2 2 0 00-4.002.002zM27 20.05a2 2 0 104.002-.003A2 2 0 0027 20.05z", fill: "currentColor" }, void 0) }), void 0));
}
exports.default = SvgMoreOptions;
//# sourceMappingURL=MoreOptions.js.map